stateProviders.push({
    name: 'schoolside.resources.information.parentApplicationInformation',
    url: '/appLink',
    templateUrl: 'fast/submodules/schoolside/resources/information/parentApplicationInformation/partials/parentApplicationInformation.html?v=' + versionNo,
    controller: 'parentApplicationInformationController',
    resolve: {
        school: function(SchoolModelService, authServiceFactory)
        {
            return SchoolModelService.resolveData(authServiceFactory.getAuth().schoolID);
        }
    }
});